import { combineReducers } from 'redux';

import { appReducer } from './app';
import { mainviewReducer } from './mainview';
import { sidebarReducer } from './sidebar';
import { modalReducer } from './modal';

export const combined = combineReducers({ 
  app: appReducer,
  mainview: mainviewReducer,
  sidebar: sidebarReducer,
  modal: modalReducer
});